import { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';

export function useAddressAutocomplete(search: string) {
  const [results, setResults] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    const trimmedSearch = search.trim();
    console.log('Autocomplete search (raw):', search);
    console.log('Autocomplete search (trimmed):', trimmedSearch);
    
    if (!trimmedSearch || trimmedSearch.length < 2) {
      setResults([]);
      setIsLoading(false);
      return;
    }

    setIsLoading(true);
    setHasError(false);

    const timeout = setTimeout(async () => {
      try {
        console.log('Calling fetchAddresses with:', trimmedSearch);
        const { data, error } = await supabase.public.fetchAddresses(trimmedSearch);
        
        if (error) {
          console.error('Error fetching addresses:', error);
          setHasError(true);
          setResults([]);
        } else {
          console.log('Autocomplete results:', data);
          setResults(data || []);
        }
      } catch (err) {
        console.error('Unexpected error in address autocomplete:', err);
        setHasError(true);
        setResults([]);
      } finally {
        setIsLoading(false);
      }
    }, 300);

    return () => clearTimeout(timeout);
  }, [search]);

  return { results, isLoading, hasError };
}
